import { isAnalyticsSupportedFactory } from './is-analytics-supported-factory';

export const isSupported = isAnalyticsSupportedFactory.async;

